import { RECAPTCHA_KEY, RECAPTCHA_V2_KEY } from '@/base/constants';
import { createEventBus } from '@/shared/js';

export const enabled = !!RECAPTCHA_KEY && !!RECAPTCHA_V2_KEY;
export const v3Bus = createEventBus<{
  action: string;
  resolve: (token: string | null) => void;
}>();
export const v2Bus = createEventBus<{
  resolve: (token: string | null) => void;
}>();
export const requestV3Token = (action: string) =>
  enabled
    ? new Promise<string | null>((resolve) =>
        v3Bus.dispatch({ action, resolve }),
      )
    : Promise.resolve(null);
export const requestV2Token = () =>
  enabled
    ? new Promise<string | null>((resolve) => v2Bus.dispatch({ resolve }))
    : Promise.resolve(null);
